import {
  SELECTED_PROVIDER,
  DOWNLOAD_PROVIDER_LIST,
  CLIENT_PROVIDER,
  ADD_NEW_DOWNLOAD_PROVIDER_LIST,
} from './../../mutation-types';

export default {
  [SELECTED_PROVIDER](state, selectedId) {
    state.selectedProvider = selectedId;
  },

  [DOWNLOAD_PROVIDER_LIST](state, providerList) {
    state.downloadExportList = providerList;
  },

  [ADD_NEW_DOWNLOAD_PROVIDER_LIST](state, newPproviderList) {
    state.downloadExportList.push(newPproviderList);
  },

  [CLIENT_PROVIDER](state, clientProvider) {
    state.clientProvider = clientProvider;
  },

};



// WEBPACK FOOTER //
// ./src/app/store/modules/providerGroup/mutations.js